import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment'
import { ExamService } from 'src/app/services/Exam/exam.service';


@Component({
  selector: 'app-admit-card-schedule',
  templateUrl: './admit-card-schedule.component.html',
  styleUrls: ['./admit-card-schedule.component.css']
})
export class AdmitCardScheduleComponent implements OnInit {

  ClassList: any;
  dropdownSettings: any = {};
  selectedItems: any = [];

  constructor(private admitservice: ExamService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  ScheduleModel = {
    ExamScheduleID: 0,
    ExamTime: moment(new Date()).format('DD-MMM-YYYY HH:mm'),
    CenterNo: '',
    ResultDate: '',
    ResultFromDate: moment(new Date()).format('DD-MMM-YYYY HH:mm'),
    ResultToDate: moment(new Date()).format('DD-MMM-YYYY HH:mm'),
    AnwersheetDate: '',
    AnwersheetFromDate: '',
    AnwersheetToDate: '',
    ClassID: 0,
    SectionID: 0,
    IsActive: true,
    ClassArray: [],
  }

  Clear() {
    this.ScheduleModel.ExamScheduleID = 0;
    this.ScheduleModel.ExamTime=moment(new Date()).format('DD-MMM-YYYY HH:mm');
    this.ScheduleModel.CenterNo='';
    this.ScheduleModel.ResultDate=moment(new Date()).format('DD-MMM-YYYY');
    this.ScheduleModel.ResultFromDate=moment(new Date()).format('DD-MMM-YYYY HH:mm');
    this.ScheduleModel.ResultToDate=moment(new Date()).format('DD-MMM-YYYY HH:mm');
    this.ScheduleModel.AnwersheetDate=moment(new Date()).format('DD-MMM-YYYY');
    this.ScheduleModel.AnwersheetFromDate=moment(new Date()).format('DD-MMM-YYYY HH:mm');
    this.ScheduleModel.AnwersheetToDate=moment(new Date()).format('DD-MMM-YYYY HH:mm');
    this.ScheduleModel.ClassID = 0;
    this.ScheduleModel.SectionID = 0;
    this.ScheduleModel.IsActive = true;
    this.ClassScheduleList.length = 0;
    this.ScheduleModel.ClassArray = [];
   
    this.Submitted = false;
  };

  ClassScheduleList = [];

  Submitted = false;
  SaveExamSchedule(valid) {
    this.ClassScheduleList = [];
    this.Submitted = true;
    var ClassIDs = this.ScheduleModel.ClassArray;
    for (var i = 0; i < this.ClassList.length; i++) {
      for (var j = 0; j < ClassIDs.length; j++) {
        if (ClassIDs[j].ItemId == this.ClassList[i].ItemId) {
          var item = {
            ClassID: this.ClassList[i].ClassID,
            SectionID: this.ClassList[i].SectionID,
          }
          this.ClassScheduleList.push(item);
        }
      }
    }


    if (valid) {
      this.spinnerService.show();
      this.ScheduleModel.ExamTime=moment(this.ScheduleModel.ExamTime).format('DD-MMM-YYYY HH:mm');
      this.ScheduleModel.ResultDate=moment(this.ScheduleModel.ResultDate).format('DD-MMM-YYYY');
      this.ScheduleModel.ResultFromDate=moment(this.ScheduleModel.ResultFromDate).format('DD-MMM-YYYY HH:mm');
      this.ScheduleModel.ResultToDate=moment(this.ScheduleModel.ResultToDate).format('DD-MMM-YYYY HH:mm');
      this.ScheduleModel.AnwersheetDate=this.ScheduleModel.AnwersheetDate!=null && this.ScheduleModel.AnwersheetDate!=''?moment(this.ScheduleModel.AnwersheetDate).format('DD-MMM-YYYY'):'';
      this.ScheduleModel.AnwersheetFromDate=this.ScheduleModel.AnwersheetFromDate!=null && this.ScheduleModel.AnwersheetFromDate!=''?moment(this.ScheduleModel.AnwersheetFromDate).format('DD-MMM-YYYY HH:mm'):'';
      this.ScheduleModel.AnwersheetToDate=this.ScheduleModel.AnwersheetToDate!=null && this.ScheduleModel.AnwersheetToDate!=''?moment(this.ScheduleModel.AnwersheetToDate).format('DD-MMM-YYYY HH:mm'):'';     
      this.admitservice.SaveExamSchedule(JSON.stringify(this.ScheduleModel), JSON.stringify(this.ClassScheduleList)).subscribe((data: any) => {
        if (data.webResponse.Status && this.ScheduleModel.ExamScheduleID == 0) {
          this.Clear();
        }
        if (data.webResponse.Status) {
          this.GetExamSchedule();
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };

  ExamScheduleList = [];
  GetExamSchedule() {
    this.spinnerService.show();
    this.admitservice.GetExamSchedule().subscribe((data: any) => {
      this.ExamScheduleList = data.ExamScheduleList;
      this.spinnerService.hide();

    });
  };



  ScheduleClassList = [];
  GetScheduleClass(obj) {
    this.Clear();
    this.ScheduleModel.ExamScheduleID = obj.ExamScheduleID;
    this.ScheduleModel.CenterNo = obj.CenterNo;
    this.ScheduleModel.IsActive = obj.IsActive;
    this.ScheduleModel.ResultDate = obj.ResultDate != null && obj.ResultDate != '' ? moment(obj.ResultDate).format('DD-MMM-YYYY') : '';
    this.ScheduleModel.ResultFromDate = obj.ResultFromDate != null && obj.ResultFromDate != '' ? moment(obj.ResultFromDate).format('DD-MMM-YYYY HH:mm') : '';
    this.ScheduleModel.ResultToDate = obj.ResultToDate != null && obj.ResultToDate != '' ? moment(obj.ResultToDate).format('DD-MMM-YYYY HH:mm') : '';
    this.ScheduleModel.ExamTime = obj.ExamTime != null && obj.ExamTime != '' ? moment(obj.ExamTime).format('DD-MMM-YYYY HH:mm') : '';
    this.ScheduleModel.AnwersheetDate = obj.AnwersheetDate != null && obj.AnwersheetDate != '' ? moment(obj.AnwersheetDate).format('DD-MMM-YYYY') : '';
    this.ScheduleModel.AnwersheetFromDate = obj.AnwersheetFromDate != null && obj.AnwersheetFromDate != '' ? moment(obj.AnwersheetFromDate).format('DD-MMM-YYYY HH:mm') : '';
    this.ScheduleModel.AnwersheetToDate = obj.AnwersheetToDate != null && obj.AnwersheetToDate != '' ? moment(obj.AnwersheetToDate).format('DD-MMM-YYYY HH:mm') : '';
    this.admitservice.GetScheduleClass(this.ScheduleModel.ExamScheduleID).subscribe((data: any) => {
      this.ScheduleClassList = data.ScheduleClassList;
      this.selectedItems = [];

      var ScheduleClassList = this.ScheduleClassList;
      for (var i = 0; i < this.ClassList.length; i++) {
        for (var j = 0; j < ScheduleClassList.length; j++) {
        
          if (ScheduleClassList[j].ClassID == this.ClassList[i].ClassID && ScheduleClassList[j].SectionID == this.ClassList[i].SectionID ) {
            let item = {
              ItemId: this.ClassList[i].ItemId,
              ItemName: this.ClassList[i].ItemName
            }
            this.selectedItems.push(item)
            
          }
        }
      }


      this.ScheduleModel.ClassArray = this.selectedItems;
   
    });
  };


  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.GetClassSection();
    this.GetExamSchedule();
  }

  GetClassSection() {
    this.lookupservice.GetLookupsList('ClassSectionList', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
      this.ClassList.splice(0, 1)
    });
  };

}
